import type { ReactNode } from 'react'
import styles from './NewsKicker.module.css'

export interface NewsKickerProps {
  children: ReactNode
  className?: string
}

/**
 * The topic label above a headline. Colored by --news-accent (dark theme) and
 * --news-accent-light (light theme) so each site supplies a readable brand
 * color; falls back to the Nexus primary.
 */
export function NewsKicker({ children, className }: NewsKickerProps) {
  return <span className={[styles.kicker, className].filter(Boolean).join(' ')}>{children}</span>
}
